<template>
    <div class="d-flex align-center flex-column">
        <v-card>
            <s-toolbar
                label="PDF de Eventos"
                dark
                :color="'#8e8f91'"
                close
                @close="$emit('close')"
                class="mb-6"
            ></s-toolbar>
            <v-card-title style="font-size: small;">
				<v-row>
					<v-col align="right">
						<v-btn 
							fab
                            style="margin-right: 40px;"
							x-small
							color="info"
							@click="downloadPdf()"
						>	<v-icon medium>mdi-printer</v-icon>				
						</v-btn>
					</v-col>
				</v-row>	
			</v-card-title>
                <hr>
                <vue-html2pdf
                :show-layout="true"
                :float-layout="false"
                :enable-download="false"
                :preview-modal="false"
                :filename="`Asignación.pdf`"
                :paginate-elements-by-height="1200"
                :pdf-quality="2"
                pdf-format="a4"
                pdf-orientation="portrait"
                pdf-content-width="800px" 
                :manual-pagination="true"
				:margin="1"
                :htmlToPdfOptions = "htmlToPdfOptions"
                @progress="onProgress($event)"
                @startPagination="startPagination()"
                @hasPaginated="hasPaginated()"
                @beforeDownload="beforeDownload($event)"
                @hasDownloaded="hasDownloaded($event)" ref="html2Pdf">
                <section slot="pdf-content">
                    <div
                        v-for="(group, pageIndex) in groupedAttendance"
                        :key="'page-' + pageIndex"
                        class="pdf-page"
                    >
                        <div style="width: 710px; margin: 30px auto; padding: 0px; box-sizing: border-box; font-size: 8px;">
                            <!-- Encabezado con 3 secciones -->
                            <div style="display: flex; width: 100%;">
                                <!-- Sección Izquierda - Logo -->
                                <div style="flex: 0.7; display: flex; justify-content: center; align-items: center;  padding: 10px;">
                                    <img src="/static/logo_sp.png" alt="Logo" style="width: 140px; height: auto;">
                                </div>

                                <!-- Sección Central - Título -->
                                <div style="flex: 1.5; display: flex; justify-content: center; align-items: center;  padding: 10px; text-align: center;">
                                    <h2 style="margin: 0; font-size: 15px; font-weight: bold; line-height: 14px;">REPORTE DE INSTRUCCIÓN</h2>
                                </div>

                                <!-- Sección Derecha - Información -->
                                <div style="flex: 1; font-size: 7px; text-align: center; font-weight: bold; line-height: 12px;">
                                    <div style="display: flex; gap: 2px;">
                                        <div style="flex: 1.5; text-align: end; white-space: nowrap;">CÓDIGO&nbsp;&nbsp;&nbsp;:</div>
                                        <div style="flex: 1; text-align: start;">RH-FR-004</div>
                                    </div>
                                    <div style="display: flex; gap: 2px;">
                                        <div style="flex: 1.5; text-align: end; white-space: nowrap;">VERSIÓN&nbsp;&nbsp;&nbsp;:</div>
                                        <div style="flex: 1; text-align: start;">03</div>
                                    </div>
                                    <div style="display: flex; gap: 2px;">
                                        <div style="flex: 1.5; text-align: end; white-space: nowrap;">Fecha de Creación&nbsp;&nbsp;&nbsp;:</div>
                                        <div style="flex: 1; text-align: start;">08/08/2016</div>
                                    </div>
                                    <div style="display: flex; gap: 2px;">
                                        <div style="flex: 1.5; text-align: end; white-space: nowrap;">Última Revisión&nbsp;&nbsp;&nbsp;:</div>
                                        <div style="flex: 1; text-align: start;">19/12/2024</div>
                                    </div>
                                    <div style="display: flex; gap: 2px;">
                                        <div style="flex: 1.5; text-align: end; white-space: nowrap;">Páginas&nbsp;&nbsp;&nbsp;:</div>
                                        <div style="flex: 1; text-align: start;">01 de 01</div>
                                    </div>
                                    <div style="display: flex; gap: 2px;">
                                        <div style="flex: 1.5; text-align: end; white-space: nowrap;">Anexos&nbsp;&nbsp;&nbsp;:</div>
                                        <div style="flex: 1; text-align: start;">00</div>
                                    </div>
                                </div>
                            </div>

                            <hr size="1" style="border-color: #000;">
                            <br>

                            <table id="pdfGestionCabecera" style="width: 200px;">
                                <thead>
                                    <tr>
                                        <th>
                                            FECHA
                                        </th>
                                        <th style="background-color: #fff;">
                                            {{ $fun.formatDateView(IasDate) }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            HORA
                                        </th>
                                        <th style="background-color: #fff;">
                                            {{ InsHors }}
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                            <br>

                            <!-- Contenido principal -->
                            <table id="pdfGestion">
                                <thead>
                                    <tr>
                                        <th colspan="5">DATOS DEL EMPLEADO PRINCIPAL</th>
                                    </tr>
                                    <tr>
                                        <th>1.- RAZÓN SOCIAL O<br>DENOMINACIÓN SOCIAL</th>
                                        <th>2.- RUC</th>
                                        <th>3.- DOMICILIO</th>
                                        <th>4.- ACTIVIDAD</th>
                                        <th>5.- N° DE TRABAJADORES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{company?.NtpFullName}}</td>
                                        <td>{{company?.NtpRuc}}</td>
                                        <td>{{company?.NtpAddress}}</td>
                                        <td>{{company?.NtpActivity}}</td>
                                        <td>{{ group.filter(p => p?.NtpFullName).length }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="display: flex; font-size: 7px; font-weight: bold; width: 100%;">
                                <div style="flex: 1; text-align: center; background-color: #e8e8e8; border-left: 0.5px solid #000; display: flex; justify-content: center; align-items: center;">Tipo de Instrucción: <br> (Instrucciones: Indicador el número en el apartado 10, acuerdo al tipo de instrucción)</div>
                                <div style="flex: 1; border-right: 0.5px solid #000; padding: 8px 4px;">
                                    <div style="display: flex;">
                                        <div style="flex: 0.6;">1.- Inducción</div><div style="flex: 1;">4.- Simulacro</div>
                                    </div>
                                    <div style="display: flex;">
                                        <div style="flex: 0.6;">2.- Capacitación</div><div style="flex: 1;">5.- Reunión</div>
                                    </div>
                                    <div style="display: flex;">
                                        <div style="flex: 0.6;">3.- Entrenamiento</div><div style="flex: 1;">6.- Otros (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)</div>
                                    </div>
                                </div>
                            </div>
                            <table id="pdfGestionCapacitor">
                                <thead>
                                    <tr>
                                        <th>N°</th>
                                        <th>6.-NOMBRE DEL CAPACITADOR</th>
                                        <th>7.-ÁREA/EMPRESA</th>
                                        <th>8.-TEMA</th>
                                        <th style="width: 80px;">9.-CÓDIGO DE<br>INSTRUCCIÓN</th>
                                        <th>10.-TIPO DE<br>INSTRUCCIÓN</th>
                                        <th style="width: 50px;">11.-TIEMPO</th>
                                        <th style="width: 120px;">12.-FIRMA</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        style="page-break-inside: avoid;"
                                        v-for="(item, index) in fixedCapacitorList"
                                        :key="'cap-' + index"
                                    >
                                        <td>{{ (index % 20) + 1 }}</td>
                                        <td>{{ item?.NtpFullName || '' }}</td>
                                        <td>{{ item?.AreAbbreviation || '' }}</td>
                                        <td>{{ item?.IsbSubject || '' }}</td>
                                        <td>{{ item?.TypeInstruction }}</td>
                                        <td>{{ item?.TypeInstructionText || '' }}</td>
                                        <td>{{ formatMinutesToTimeLabel(item?.IinDurationTime) || '' }}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <tfoot style="page-break-inside: avoid;">
                                    <tr>
                                        <td colspan="5" style="border-left: 1px solid white; border-bottom: 1px solid white;"></td>
                                        <td style="background-color: #e8e8e8; font-weight: bold;">13.-TOTAL</td>
                                        <td>{{ formatMinutesToTimeLabel(totalMinutes) }}</td>
                                        <td style="border-right: 1px solid white; border-bottom: 1px solid white;"></td>
                                    </tr>
                                </tfoot>
                            </table>
                            <div style="font-size: 9px; font-weight: bold; text-align: center; page-break-inside: avoid;">RELACIÓN DE PARTICIPANTES</div>
                            <table id="pdfGestionCapacitor">
                                <thead>
                                    <tr style="page-break-inside: avoid;">
                                        <th>N°</th>
                                        <th>14.-APELLIDOS Y NOMBRES</th>
                                        <th>15.-DNI</th>
                                        <th>16.-AREA</th>
                                        <th>17.-FIRMA</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        style="page-break-inside: avoid;"
                                        v-for="(item, index) in group"
                                        :key="'att-' + index + '-pg' + pageIndex"
                                    >
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ item.NtpFullName }}</td>
                                        <td>{{ item.PrsDocumentNumber }}</td>
                                        <td>{{ item.AreAbbreviation }}</td>
                                        <td style="width: 140px;"></td>
                                    </tr>
                                </tbody>
                            </table>
                            <br>
                            <div style="display: flex; width: 100%; justify-content: space-between; page-break-inside: avoid;">
                                <div style="display: flex; flex-direction: column; width: 250px;">
                                    <table id="pdfGestion">
                                        <thead>
                                            <tr>
                                                <th>18.-OBSERVACIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style="text-align: left;">
                                                    <div style="min-height: 40px;">
                                                        {{InsObject?.InsObservation}}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div style="display: flex; flex-direction: column; width: 400px;">
                                    <table id="pdfGestion">
                                        <thead>
                                            <tr>
                                                <th>19.-RESPONSABLE DEL REGISTRO</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style="text-align: left;">
                                                    <b>Nombre del encargado:</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left;">
                                                    <b>Área a Cargo:</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left;">
                                                    <div style="min-height: 40px;">
                                                        <b>Firma:</b>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div v-if="pageIndex < groupedAttendance.length - 1" class="html2pdf__page-break" />
                    </div>
                </section>
            </vue-html2pdf>
        </v-card>
    </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf';
import InstructionInstructorService from "@/services/Management/InstructionInstructorService";
import InstructionAttendanceService from "@/services/Management/InstructionAttendanceService";
import { DateTime, Duration } from 'luxon';

export default{ 
    
    props:{
        InsObject: {
            type: Object,
            default: null,
        },
        IasDate: {
            type: String,
            default: null,
        }
    },
    components:{
        VueHtml2pdf
    },
    data(){
        return{
            htmlToPdfOptions: {
                filename: `Reporte_de_Instruccion.pdf`,
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'portrait'
                },
                html2canvas: {
                useCORS: true,
                scale: 5,
                },
            },
            company: {
                NtpFullName: "SUNSHINE EXPORT SAC",
                NtpRuc: "20329725431",
                NtpAddress: "CARRETERA TAMBOGRANDE, LAS LOMAS KM 1077 + 179 - PIURA",
                NtpActivity: "AGROINDUSTRIA",
            },
            parametersPagination: null,
            itemCapacitor: [],
            itemAttendance: [],
            InsHors: null,
            totalMinutes: 0,
            groupedAttendance: [],
        }
    },
    computed: {
        fixedCapacitorList() {
            const count = this.itemCapacitor.length;
            const needed = 6 - count;
            return [...this.itemCapacitor, ...Array(needed > 0 ? needed : 0).fill({})];
        },
    },
    methods:{
        formatMinutesToTimeLabel(minutes) {
            if (!minutes || isNaN(minutes)) return '';

            const duration = Duration.fromObject({ minutes });

            if (minutes < 60) {
                return `${minutes} min`;
            } else {
                const hours = Math.floor(duration.as('hours'));
                const mins = duration.minutes % 60;

                return mins === 0
                ? `${hours} h`
                : `${hours}:${mins.toString().padStart(2, '0')} h`;
            }
        },
         getGroupedAttendance(attendanceList) {
            const groupSize = 20;
            const result = [];
            for (let i = 0; i < attendanceList.length; i += groupSize) {
            let group = attendanceList.slice(i, i + groupSize);
            const missing = groupSize - group.length;
            if (missing > 0) {
                group = [...group, ...Array(missing).fill({})];
            }
            result.push(group);
            }
            return result;
        },
        downloadPdf(){
            this.$refs.html2Pdf.generatePdf();
        },
        onProgress(progress) {
            this.progress = progress;
            //console.log(`PDF generation progress: ${progress}%`)
        },
        startPagination() {
            //console.log(`PDF has started pagination`)
        },

        hasPaginated () {
            //console.log(`PDF has been paginated`)
        },

        beforeDownload ({ html2pdf, options, pdfContent }) {
            //console.log(`On Before PDF Generation`)
                html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                    // const totalPages = pdf.internal.getNumberOfPages()
                    // for (let i = 1; i <= totalPages; i++) {
                    // 	pdf.setPage(i)
                    // 	pdf.setFontSize(10)
                    // 	pdf.setTextColor(150)
                    // 	pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                    // } 
                }).save()
        },
    },
    watch: {

    },
    mounted() {

    },
    created() {
        console.log(this.InsObject);

        this.parametersPagination = {
            filter: {
                InsID: this.InsObject?.InsID,
                IasDate: this.IasDate,
            },
            draw: 1,
            start: 0,
            length: -1,
            order: [{ dir: "asc", column: "" }],
            searchText: "",
        };

        InstructionInstructorService.pagination(this.parametersPagination, this.$fun.getUserID()).then(resp => {
            if (resp.status == 200) {
                console.log(resp.data.data);
                this.itemCapacitor = resp.data.data;

                this.InsHors = this.itemCapacitor.reduce((min, curr) => {
                    const currTime = DateTime.fromFormat(curr.IInicioTime, 'HH:mm');
                    const minTime = DateTime.fromFormat(min.IInicioTime, 'HH:mm');
                    return currTime < minTime ? curr : min;
                }).IInicioTime;

                this.totalMinutes = this.itemCapacitor.reduce((sum, item) => sum + (item.IinDurationTime || 0), 0);
            }
        });

        InstructionAttendanceService.pagination(this.parametersPagination, this.$fun.getUserID()).then(resp => {
            if (resp.status == 200) {
                this.itemAttendance = resp.data.data;
                this.groupedAttendance = this.getGroupedAttendance(this.itemAttendance);
            }
        });
    }
}
</script>
<style>
#pdfGestion,
#pdfGestionCabecera,
#pdfGestionCapacitor{
    border-collapse: collapse;
    border: 0.1mm solid #000 !important;
    width: 100%;
    color: #000;
    font-size: 7px;
}

#pdfGestion th,
#pdfGestion td,
#pdfGestionCabecera th,
#pdfGestionCabecera td,
#pdfGestionCapacitor th,
#pdfGestionCapacitor td{
    border: 0.1mm solid #000 !important;
    padding: 4px;
    text-align: center;
}

#pdfGestion th,
#pdfGestionCabecera th,
#pdfGestionCapacitor th{
    background-color: #e8e8e8;
    font-weight: bold;
    text-align: center;
}

#pdfGestionCabecera th{
    width: 50%;
}
</style>